import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/hand.vue
var s = {
	name: "DtIconHand",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--hand"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Hand",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M4.94.94a1.5 1.5 0 0 1 2.324.253 1.5 1.5 0 0 1 2.183.913A1.5 1.5 0 0 1 11.5 3.5V7A4.5 4.5 0 0 1 7 11.5H6c-1.534 0-2.51-.484-3.347-1.315l-.002-.001-1.8-1.8A1.5 1.5 0 0 1 2.5 5.966V2.5a1.5 1.5 0 0 1 2.236-1.307 1.5 1.5 0 0 1 .203-.254ZM4.5 2.5v2.75a.5.5 0 0 0 1 0V2a.5.5 0 1 1 1 0v3a.5.5 0 0 0 1 0V2.5a.5.5 0 1 1 1 0v3a.5.5 0 0 0 1 0v-2a.5.5 0 1 1 1 0V7A3.5 3.5 0 0 1 7 10.5H6c-1.265 0-1.99-.376-2.642-1.024L1.569 7.687a.5.5 0 0 1 .707-.704l.37.37.5.5a.5.5 0 1 0 .708-.707L3.5 6.793V2.5a.5.5 0 1 1 1 0Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=hand.js.map